import shipbiteLogo from "url:../../img/shipbite-logo.png";
import bankistLogo from "url:../../img/bankist-logo.png";

//My skills
export const skills = [
  "HTML5",
  "CSS3",
  "SCSS",
  "JavaScript",
  "OOP",
  "MVC",
  "Git",
  "GitHub",
  "Supabase",
  "PostgreSQL",
  "OpenAI API",
  "Chart.js",
  "GSAP",
  "ScrollTrigger",
  "Parcel",
  "BEM",
  "Netlify",
  "REST API",
  "Responsive Design",
  "CSS Grid",
  "Flexbox",
];

//Storing projects data for rendering
export const projectsData = [
  {
    title: "Shipbite",
    concept: "AI FOOD ORDERING",
    desc: "Un assistente conversazionale che trasforma il modo in cui i clienti ordinano da un fast food / ristorante . Niente app, niente registrazioni , niente processo di checkout lungo, solo una chat naturale",
    logo: shipbiteLogo,
    stack: [
      { tech: "html5", label: "Markup semantico e accessibile" },
      { tech: "css", label: "Layout e animazioni responsive" },
      { tech: "sass", label: "Design system scalabile con BEM" },
      { tech: "javascript", label: "Architettura MVC e logica business" },
      { tech: "supabase", label: "Database realtime e autenticazione" },
      { tech: "chart-js", label: "Dashboard analytics per l'admin" },
    ],
    previewLink: "https://shipbite.netlify.app/",
  },

  {
    title: "Bankist",
    concept: "MINIMALIST BANKING APP",
    desc: "Un'app bancaria minimalista che permette di gestire conti, effettuare trasferimenti e monitorare i movimenti in tempo reale con un'interfaccia pulita e animazioni fluide che rendono la gestione finanziaria intuitiva",
    logo: bankistLogo,
    stack: [
      { tech: "html5", label: "Markup semantico e accessibile" },
      { tech: "css", label: "Layout e animazioni responsive" },
      { tech: "sass", label: "Design system scalabile con BEM" },
      { tech: "javascript", label: "Architettura MVC e logica business" },
    ],
    previewLink: "https://minimalbankist.netlify.app/",
  },
];
